import { Button } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";

export const Navigation = ({ onRsvpClick, onClickHome }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const handleNavClose = () => {
    setIsNavOpen(false);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle ${isNavOpen ? "collapsed" : ""}`}
            onClick={() => setIsNavOpen(!isNavOpen)}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <img src="img/LogoSmall.png" style={{ cursor: 'pointer' }} onClick={() => {
    window.location.href = "https://flipkartconnect2026.com";
  }} className="navbar-brand page-scroll" alt="" />
        </div>

        <div className={`collapse navbar-collapse ${isNavOpen ? "in" : ""}`}>
          <ul className="nav navbar-nav navbar-right">
            {/* <li>
              <a  className="page-scroll" style={{cursor:'pointer'}} onClick={() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}}>
                Flipkart Connect
              </a>
            </li> */}
            {/* <li>
              <a href="#services" className="page-scroll" onClick={handleNavClose}>
                Agenda
              </a>
            </li> */}
            {/* <li>
              <a href="#about" className="page-scroll" onClick={handleNavClose}>
                Workshop
              </a>
            </li> */}

            {/* <li>
              <a href="/jury" className="page-scroll" onClick={handleNavClose}>

                Jury 4.0

              </a>

            </li> */}
            {/* <li>

              <a onClick={handleNavClose}>
                <Link to={"/jury"} className="page-scroll linktojury" style={{ color: "#fff" }} onClick={handleNavClose}>

                  Jury
                </Link>
              </a>

            </li> */}
            {/* <li>

              <a onClick={handleNavClose}>
                <Link to={"/gallery"} className="page-scroll linktojury" style={{ color: "#fff" }} onClick={handleNavClose}>

                  Gallery
                </Link>
              </a>

            </li> */}
            {/* <li>
              <a href="#lastedition" className="page-scroll" onClick={handleNavClose}>
                Last Edition
              </a>
            </li> */}

            {/* <li>
              <Button type="primary" href="#signup" className="rsvpnowbtn" onClick={onRsvpClick}>
                RSVP NOW
              </Button>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};
